import React from 'react';
import styled from 'styled-components';

interface ParagraphProps {
    children: React.ReactNode;
    maxWidth?: string;
}

const StyledParagraph = styled.p<{ $maxWidth?: string }>`
    font-size: ${({ theme }) => theme.fontSizes.paragraph};
    font-weight: ${({ theme }) => theme.fontWeights.normal};
    line-height: 1.6;
    max-width: ${({ $maxWidth }) => $maxWidth || '100%'};
    margin-bottom: ${({ theme }) => theme.spacing.lg};
    
    &:last-child {
        margin-bottom: 0;
    }
`;

export const Paragraph: React.FC<ParagraphProps> = ({ children, maxWidth }) => {
    return <StyledParagraph $maxWidth={maxWidth}>{children}</StyledParagraph>;
};
